import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { allFaqsNamo } from "../../../functionsMaster";

const Faq = () => {
const routes = all_routes
    
  return (
    <>
      {/* Breadscrumb */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">FAQ</h2>
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.homeTwo}>Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Pages</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    FAQ
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* /Breadscrumb */}
      <section className="section faq-section">
        <div className="container">
          <div className="faq-info">


                {allFaqsNamo.map((s, i) => (
                  <div className="faq-card bg-white" key={`faqs${i}`} data-aos="fade-down">
                    <h4 className="faq-title">
                      <Link
                        className="collapseds"
                        data-bs-toggle="collapse"
                        to={`#faqs${i}`}
                        aria-expanded={i === 0}
                      >
                        {s.question}
                      </Link>
                    </h4>
                    <div id={`faqs${i}`} className={`card-collapse collapse ${i === 0 ? 'show' : ''}`}>
                      <p>{s.answer}</p>
                    </div>
                  </div>
                ))}

          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
